export const appSettings = "";
export const RoutesPaths = {
  HOME: `${appSettings}/`,
  DASHBOARD: `${appSettings}/dashboard`,
  PEOPLE_AI_BASE: `${appSettings}/c/:id`,
  PEOPLE_AI_TRACKING: `${appSettings}/c/:id/:tracking`,
  COMPANY_SETTINGS: `${appSettings}/company-select`,
  LANDING: `${appSettings}/home`,
  OLD_PAYMENT: `${appSettings}/oldpayment`,
  PAYMENT: `${appSettings}/payment`,
  PAIDUPDETAIL: `${appSettings}/payment/paidup`,
  PAIDUPDETAILPAYMENT: `${appSettings}/payment/:slug`,
  PAYMENT_BANK_TRANSFER: `${appSettings}/payment/:slug/banktransfer`,
  PAYMENT_BANK_DETAIL: `${appSettings}/payment/:slug/banktransfer/bankdetail`,
  PAYMENT_MAKEPAYMENT: `${appSettings}/payment/:slug/banktransfer/makepayment`,
  SHARE_PAGE: `${appSettings}/ud/:id`,


  PAY_PAIDUP_PAGE_LIST: `${appSettings}/share-paid-up-capital`,
  PAY_PAIDUP_PAGE: `${appSettings}/share-paid-up-capital/:slug`,
  PAY_PAIDUP_BANKTRANSFER: `${appSettings}/share-paid-up-capital/:slug/banktransfer`,
  PAY_PAIDUP_BANKDETAIL: `${appSettings}/share-paid-up-capital/:slug/banktransfer/bankdetail`,
  PAY_PAIDUP_MAKEPAYMENT: `${appSettings}/share-paid-up-capital/:slug/banktransfer/makepayment`,


  SHARECAPITAL: `${appSettings}/share-paid-up-capital`,
  SHARECAPITALADD: `${appSettings}/share-paid-up-capital/sharecapital`,
  PAIDUPCAPITALPAY: `${appSettings}/share-paid-up-capital/sharecapital/Paid-up-capital`,
  FILE: `${appSettings}/file`,
  INVITE: `${appSettings}/invite`,
  TASK: `${appSettings}/task`,
  SIGNIN: `${appSettings}/sign-in`,
  SIGNUP: `${appSettings}/sign-up`,
  LANDING_PUBLIC: `${appSettings}/`,
  SET_PASSWORD: `${appSettings}/set-password`,
  ADD_BUSINESS_PUBLIC: `${appSettings}/add-business`,
  FORGOT_PASSWORD: `${appSettings}/forgot-password`,
  RESET_PASSWORD: `${appSettings}/reset-password/:token`,
  PROFILE: `${appSettings}/profile`,
  ACCOUNTSETTING: `${appSettings}/editprofile`,
  SECURITY: `${appSettings}/security`,
  VERIFICATION: `${appSettings}/verification`,
  ADMIN_LOGIN_VERIFICATION: `${appSettings}/admin/verification/:userId/:adminId/:company`,
  INVITE_ACCEPT: `${appSettings}/promoter/:token`,
  VERIFY_EMAIL: `${appSettings}/verify-email/:token`,
  STRIPE_PAYMENT: `${appSettings}/stripe`,
  MYINFOCALLBACK: `${appSettings}/callback`,
  MYINFO_STATUS_CALLBACK: `${appSettings}/myinfo-callback`,
  MYINFOPROCESS: `${appSettings}/process`,
  LINKEDINCALLBACK: `${appSettings}/linkedin/callback`,
  MESSAGE_DETAIL: `${appSettings}/chat`,
  MESSAGE_DETAIL_PUBLIC_CHAT: `${appSettings}/gs/:id`,
  MESSAGE_DETAIL_PUBLIC_CHAT_CAMPAIGN: `${appSettings}/gs/:id/:campaignId`,
  MESSAGE_DETAIL_PUBLIC: `${appSettings}/gs`,
  CHAT_BOT: `${appSettings}/chat-bot`,
  BOOK_OF_BUSINESS: `${appSettings}/book-of-business`,
  BANKTRANSFER: `${appSettings}/formalise/:slug/banktransfer`,
  BANKDETAIL: `${appSettings}/formalise/:slug/banktransfer/bankdetail`,
  MAKEPAYMENT: `${appSettings}/formalise/:slug/banktransfer/makepayment`,
  DASHBOARD_BANKTRANSFER: `${appSettings}/dashboard/:slug/banktransfer`,
  DASHBOARD_BANKDETAIL: `${appSettings}/dashboard/:slug/banktransfer/bankdetail`,
  DASHBOARD_MAKEPAYMENT: `${appSettings}/dashboard/:slug/banktransfer/makepayment`,
  E_SIGN: `${appSettings}/e-sign`,
  SUCCESS_SIGNNOW: `${appSettings}/success-signnow`,
  PRODUCT_PAGE: `${appSettings}/formalise/:slug`,
  DASHBOARD_PRODUCT_PAGE: `${appSettings}/dashboard/:slug`,
  PRODUCTS_LIST_PAGE: `${appSettings}/formalise`,
  // PRODUCT_LANDING_PAGE: `${appSettings}/product-landing`,
  PRODUCT_THANK_YOU: `${appSettings}/thank-you`,
  BOOK_OF_BUSINESS_PRODUCT_PAGE: `${appSettings}/book-of-business/:slug`,
  BOOK_OF_BUSINESS_BANKTRANSFER: `${appSettings}/book-of-business/:slug/banktransfer`,
  BOOK_OF_BUSINESS_BANKDETAIL: `${appSettings}/book-of-business/:slug/banktransfer/bankdetail`,
  BOOK_OF_BUSINESS_MAKEPAYMENT: `${appSettings}/book-of-business/:slug/banktransfer/makepayment`,
  PAY_PRODUCT_PAGE: `${appSettings}/pay/:slug`,
  PAYNOW_SUCCESS: `${appSettings}/payment/success`,
  PAYNOW_FAILED: `${appSettings}/payment/cancel`,
  PAYNOW_SUCCESS_BY_SLUG: `${appSettings}/pay/:slug/success`,
  PAYNOW_FAILED_BY_SLUG: `${appSettings}/pay/:slug/failed`,
  PAY_BANKTRANSFER: `${appSettings}/pay/:slug/banktransfer`,
  PAY_BANKTRANSFER_PUBLIC: `${appSettings}/pq/:slug`,
  QUOTATION_PUBLIC: `${appSettings}/qp/:slug`,
  PUBLIC_PAYMENT_STATUS: `${appSettings}/ps/:slug/:id`,
  PAY_BANKDETAIL: `${appSettings}/pay/:slug/banktransfer/bankdetail`,
  PAY_MAKEPAYMENT: `${appSettings}/pay/:slug/banktransfer/makepayment`,
  ACCOUNT_CLOSE_FORM: `${appSettings}/account-close-form`,
  ADD_COMPANY: `${appSettings}/add-company`,
  ACTIVATE_BUSINESS: `${appSettings}/activate-business`,
  ERROR_PAGE: `${appSettings}/404`,
  INVITE_PUBLIC: `${appSettings}/in`,
  INVITE_PUBLIC_PROMOTER: `${appSettings}/in/p`,
  INVITE_PUBLIC_SHAREHOLDER: `${appSettings}/in/s`,
  INVITE_PUBLIC_DIRECTOR: `${appSettings}/in/d`,
  VIEW_TASK: `${appSettings}/view/task/:id`,
};
